exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".apply_list[data-v-0b5d1266]{margin:30px auto}\n", ""]);

// exports
